<template>
  <div class="user_box" id="user_box">
    <div class="bg_box">
    </div>
    <div class="user_top_box">
      <div class="user_top_img"><img :src="userData.userimg"></div>
      <div class="user_top_nm">{{userData.usernick}}</div>
    </div>
    <div class="user_index_box">
      <div class="user_index_list" @click="gotogz()">
        <span class="user_index_list_l">我的关注</span>
        <var class="kf_icon"></var>
      </div>
      <div class="user_index_list" @click="toastkefu()">
        <span class="user_index_list_l">联系客服</span>
        <var class="kf_icon"></var>
      </div>
      <div class="user_index_list" @click="toastemail()">
        <span class="user_index_list_l">商务合作</span>
        <var class="kf_icon"></var>
      </div>
    </div>
    
    <tab-bar :current-index="1" />
    <van-popup v-model="servicePop" 
    closeable
    :close-on-click-overlay="false"
    close-icon="close" class="servicePop">
      <img src="../assets/images/ewm.jpg"/>
      <p>添加官方微信客服</p>
    </van-popup>
    <van-popup v-model="emailPop" 
    closeable
    :close-on-click-overlay="false"
    close-icon="close" class="emailPop">
      <p>邮箱：ksl2022@126.com</p>
    </van-popup>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import API from "../api";
import axios from "axios";
import qs from 'qs';
import TabBar from '../components/tabbar.vue';
// import { Message } from 'element-ui'
import {
  Popup as VanPopup,
  Image as VanImage,
  Toast
} from 'vant';
export default {
  name: "",
  
  components: {
   TabBar,
   VanImage,
   VanPopup,
  },
  data() {
    return {
      userData:{},
      servicePop:false,
      emailPop:false,
    };
  },
  mounted() {
   this.getUserInfo();
  },
  
  methods: {
    async getUserInfo(){ //用户信息
      //this.toDay = formatDate(new Date(), 'yyyy-MM-dd')
      //console.log(this.toDay)
      
      const res = await API.getUserInfo();
      
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.userData = res.data.data;
        //console.log(this.userData)
        //console.log(res.data.data.data1)
      } else {
        Toast(res.data.message);
      }
    },
    toastkefu(){
      //Toast("微信搜索“wonder341224”添加官方客服微信。");
      this.servicePop=true;
    },
    toastemail(){
      //Toast("微信搜索“wonder341224”添加官方客服微信。");
      this.emailPop=true;
    },
   gotogz(){
      this.$router.push({ name: 'myconcerned'});
    }
  }
};
</script>



// WEBPACK FOOTER //
// user.vue?2672b98c